'use client'

import { IconDown } from 'icons/components/IconDown'
import { IconUpLarge } from 'icons/components/IconUpLarge'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { forwardRef } from 'react'
import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './RegisterButton.module.scss'

type RegionsButtonProps = {
	readonly label: string
	readonly dataTestId?: string
	readonly isOpen: boolean
	readonly onClick?: () => void
}

export const RegionsButton = forwardRef<HTMLButtonElement, RegionsButtonProps>(
	function RegionsButton(
		{ label, dataTestId, isOpen, onClick }: RegionsButtonProps,
		ref: React.ForwardedRef<HTMLButtonElement>
	) {
		const { t } = useLabels()

		return (
			<button
				ref={ref}
				aria-label={t('accessibility.sizeGuide.internationalEquivalence')}
				aria-haspopup='listbox'
				aria-expanded={isOpen}
				type='button'
				onClick={onClick}
				className={cx(styles.button, text.bodyM)}
				data-testid={dataTestId}
			>
				<span>{label}</span>
				{isOpen ? <IconUpLarge /> : <IconDown />}
			</button>
		)
	}
)
